import { AnalysResultatDTO } from 'src/app/pages/models/analys-resultat';
import { IconBadgeColumn } from '../components/app-table/app-table-models';
import { NameStatus, NameType } from './models';

export interface AtgardTableRow {
  label?: string;
  value?: string;
  originalValue?: string;
  atgarda?: boolean;
  namntyp?: NameType;
  status?: OkantNamnStatus;
  labbKod?: string;
}

export enum OkantNamnStatus {
  Ignorerad = 'IGNORERAD',
  Parkerad = 'PARKERAD',
  Synonymiserad = 'SYNONYMISERAD',
  NyttStandardnamn = 'NYTT_STANDARDNAMN',
  AtgardBehovs = 'ATGARD_BEHOVS',
}

export interface AtgardStatus {
  ignored?: boolean;
  nameStatus?: NameStatus;
  parked?: boolean;
}

export interface ParkComment {
  created: Date;
  anvandare_id: string;
  kommentar: string;
}

export interface AnalysRestultatID {
  id: string;
  created: Date;
}

export interface ProvAndAnalysID {
  id: string;
  provId: string;
  analysResultat: AnalysRestultatID[];
  antibioticDuplicates: boolean;
}

export interface Oversikt {
  name: string;
  type: NameType;
  labCode: string;
  prov: ProvAndAnalysID;
  parked: true;
  duplicate: false;
  parking_comments: ParkComment[];
  num: number;
  provId: string;
  rowidentifier: string;
  customTitle: string;
  icon: IconBadgeColumn;
  details: AnalysResultatDTO;
  selectedField?: string;
}

export enum Anitbiotikadubblett {
  AUTOMATISK_HANTERING = 'AUTOMATISK_HANTERING',
  INGEN_DUBBLETT = 'INGEN_DUBBLETT'
}